import { useParams } from 'react-router';

export function useIsInEmbedSearchWidget() {
  const params = useParams();

  return { isInEmbedSearchWidget: Boolean(params.embedSearchWidgetId) };
}
